import classNames from "classnames";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import Sidebar from "src/components/molecules/Navigation/Sidebar";
import BrandHeader from "src/components/molecules/BrandHeader";

const Product = () => {
  const stateMenu = useSelector((state) => state.menu.value);

  const ClassSidebarWrapper = classNames(
    "fixed top-0 bottom-0 z-40 w-full bg-white border-r transition-transform duration-500",
    "md:relative md:w-[247px] md:translate-x-0",
    {
      "translate-x-0": stateMenu,
      "-translate-x-full": !stateMenu, 
    }
  );

  return (
    <div className="flex min-h-screen bg-[#F3F3F3]">
      <aside className={ClassSidebarWrapper} aria-label="Sidebar Navigation">
        <div className="h-full overflow-y-auto md:pt-20 pt-[112px]">
          <Sidebar />
        </div>
      </aside>

      <main className="flex-1 bg-white">
        <BrandHeader />
        <Outlet />
      </main>
    </div>
  );
};

export default Product;
